import AnalyticService from '@justeat/f-analytics';

export default (context, inject) => {
    const { store, req } = context;
    const { configuration, globalisation } = store.state;
    const options = {
        featureName: 'coreweb',
        locale: globalisation.locale,
        id: configuration.settings.gtm.id,
        auth: configuration.settings.gtm.auth,
        cookiesWin: configuration.settings.gtm.cookiesWin,
        preview: configuration.settings.gtm.preview
    };

    const service = new AnalyticService(store, req, options);

    inject(service.getOptions().globalVarName, service);

    service.pushPlatformData();
};
